import { resourceSliceFactory } from "infrastructure/store/state";
import { MenuItem } from "consts/shipmentTracking";
import type { ShipmentTrackingState } from "./types";

const state: ShipmentTrackingState = {
    [MenuItem.TransactionTrackingDeliveryCodes]: resourceSliceFactory()
};

export const sliceToken = 'shipmentTracking';

export default state;
